module.exports = __webpack_public_path__ + "img/Metastasis-PDAC_GSE205354.1ab91c36.png";